import React, { useEffect, useState } from 'react';
import { ccmApi } from '../lib/api';

// Note Expander v2, "Earlier feedback" (PR 5-UI-2, O191; brief PR 5; OQ-8): the ratings and comments
// this clinician gave the earlier expander, read-only from v1's own route (GET
// /api/note-expander/feedback/recent: a provider sees their own). The passive signed-note diffs
// (kind edit_diff) are not listed. Nothing here is applied to a v2 run.

export function NoteExpanderV2Feedback() {
  const [state, setState] = useState({ loading: true });

  useEffect(() => {
    let live = true;
    ccmApi.noteExpanderFeedbackRecent({ limit: 50 })
      .then((r) => { if (live) setState({ rows: (r.feedback || []).filter((f) => f.kind !== 'edit_diff') }); })
      .catch((e) => { if (live) setState({ error: e && e.status === 403 ? 'off' : 'failed' }); });
    return () => { live = false; };
  }, []);

  return (
    <div className="ne2-prefs">
      <p className="ne2-prefs-lede">What you told the earlier expander. Read-only; it is not applied to new expansions.</p>
      {state.loading && <div className="ne-empty">Loading…</div>}
      {state.error === 'off' && <div className="ne-empty">Feedback was not turned on for this practice.</div>}
      {state.error === 'failed' && <div className="ne-error" role="alert">Earlier feedback could not be loaded.</div>}
      {state.rows && !state.rows.length && <div className="ne-empty">No earlier feedback.</div>}
      {state.rows && state.rows.map((f) => (
        <section key={f.id} className="ne2-pref">
          <div className="ne2-pref-head">
            <h3>{f.rating === 'up' ? 'Helpful' : f.rating === 'down' ? 'Not helpful' : 'Comment'}</h3>
            <p>{String(f.created_at || '').slice(0, 10)}{(f.tags || []).length ? ` · ${f.tags.join(', ')}` : ''}</p>
          </div>
          {f.comment && <blockquote className="ne2-old-text">{f.comment}</blockquote>}
        </section>
      ))}
    </div>
  );
}
